import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import AsyncStorage from '@react-native-async-storage/async-storage';
import selectedBuildingReducer from './selectedBuildingSlice';
import dateRangeReducer from './dateRangeSlice';
import dateComparisonRangeReducer from './dateComparisonRangeSlice';
import ticketsFilterReducer from './ticketsFilterSlice';
import assetsFilterReducer from './assetsFilterSlice';
import devStateReducer from './devStateSlice';
import happyEnabledReducer from './happyEnabledSlice';
import sensorsFilterReducer from './sensorsFilterSlice';
import selectedTicketReducer from './selectedTicketSlice';
import locationStructureReducer from './locationStructureSlice';
import userReducer from './userSlice';
import emptyStateReducer from './emptyStateSlice';
import mapScreenReducer from './mapScreenSlice';
import liveDateRangeReducer from './liveDateRangeSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage: AsyncStorage,
  blacklist: ['selectedTicket'],
};

const reducer = combineReducers({
  selectedBuilding: selectedBuildingReducer,
  dateRange: dateRangeReducer,
  dateComparisonRange: dateComparisonRangeReducer,
  ticketsFilter: ticketsFilterReducer,
  assetsFilter: assetsFilterReducer,
  devState: devStateReducer,
  happyEnabled: happyEnabledReducer,
  sensorsFilter: sensorsFilterReducer,
  selectedTicket: selectedTicketReducer,
  locations: locationStructureReducer,
  user: userReducer,
  emptyState: emptyStateReducer,
  mapScreen: mapScreenReducer,
  liveDateRange: liveDateRangeReducer,
});

export const store = configureStore({
  reducer: persistReducer(persistConfig, reducer),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);
